module.exports = __webpack_public_path__ + "static/media/sumavigroup ui-07.e397abe0.svg";